import { apiClient } from "./client";

/**
 * Triggers a browser download of the monthly PDF report.
 * Returns the suggested filename (parsed from Content-Disposition).
 */
export async function downloadMonthlyReportPdf(
  organizationId: string,
  year: number,
  month: number,
): Promise<string> {
  const response = await apiClient.get<Blob>(
    `/api/v1/plannings/${organizationId}/${year}/${month}/report.pdf`,
    { responseType: "blob", timeout: 60_000 },
  );
  // Parse filename
  const disposition = response.headers["content-disposition"] as string | undefined;
  let filename = `cortex-planning_${year}-${month.toString().padStart(2, "0")}.pdf`;
  if (disposition) {
    const match = /filename="?([^"]+)"?/i.exec(disposition);
    if (match && match[1]) filename = match[1];
  }
  // Trigger download
  const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
  return filename;
}


/**
 * Triggers a browser download of the yearly rollup PDF report (12 months).
 */
export async function downloadYearlyReportPdf(
  organizationId: string,
  year: number,
): Promise<string> {
  const response = await apiClient.get<Blob>(
    `/api/v1/organizations/${organizationId}/reports/yearly/${year}.pdf`,
    { responseType: "blob", timeout: 120_000 },
  );
  const disposition = response.headers["content-disposition"] as string | undefined;
  let filename = `cortex-planning_${year}_annuel.pdf`;
  if (disposition) {
    const match = /filename="?([^"]+)"?/i.exec(disposition);
    if (match && match[1]) filename = match[1];
  }
  const url = window.URL.createObjectURL(
    new Blob([response.data], { type: "application/pdf" }),
  );
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
  return filename;
}
